import { createBrowserRouter, redirect } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import LoginPage from '@/pages/auth/LoginPage'
import DashboardPage from '@/pages/dashboard/DashboardPage'
import OrdersPage from '@/pages/orders/OrdersPage'
import OrderDetailPage from '@/pages/orders/OrderDetailPage'
import DriversPage from '@/pages/drivers/DriversPage'
import DriverDetailPage from '@/pages/drivers/DriverDetailPage'
import CustomersPage from '@/pages/customers/CustomersPage'
import CustomerDetailPage from '@/pages/customers/CustomerDetailPage'
import UsersPage from '@/pages/users/UsersPage'
import TenantsPage from '@/pages/tenants/TenantsPage'
import SettingsPage from '@/pages/settings/SettingsPage'
import DriverReportPage from '@/pages/reports/DriverReportPage'
import CustomerReportPage from '@/pages/reports/CustomerReportPage'
import VendorRebateReportPage from '@/pages/reports/VendorRebateReportPage'
import XunanSignReportPage from '@/pages/reports/XunanSignReportPage'
import DriverMyReportPage from '@/pages/reports/DriverMyReportPage'
import BatchOrdersPage from '@/pages/batchOrders/BatchOrdersPage'
import DispatchBoardPage from '@/pages/dispatchBoard/DispatchBoardPage'
import DocumentTestPage from '@/pages/reports/DocumentTestPage'
import BookingPage from '@/pages/booking/BookingPage'
import TenantBookingPage from '@/pages/booking/TenantBookingPage'
import TenantBookingPageV2 from '@/pages/booking/TenantBookingPageV2'
import DriverSignPage from '@/pages/driverSign/DriverSignPage'
import ExpensesPage from '@/pages/expenses/ExpensesPage'
import DriverMyExpensesPage from '@/pages/expenses/DriverMyExpensesPage'

const checkAuth = () => {
  const token = localStorage.getItem('access_token')
  if (!token) {
    return redirect('/login')
  }
  return null
}

const checkSuperAdmin = () => {
  const token = localStorage.getItem('access_token')
  if (!token) return redirect('/login')
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.role !== 'super_admin' && user.role !== 'tenant_admin') return redirect('/dashboard')
  return null
}

const checkBatchOrdersAccess = () => {
  const token = localStorage.getItem('access_token')
  if (!token) return redirect('/login')
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user.role === 'driver') return redirect('/dashboard')
  const tenant = JSON.parse(localStorage.getItem('tenant') || '{}')
  if (!tenant?.form_config?.enable_batch_orders) return redirect('/dashboard')
  return null
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/booking/:token',
    element: <BookingPage />,
  },
  {
    path: '/booking/tenant/:token',
    element: <TenantBookingPage />,
  },
  {
    path: '/booking/tenant/:token/v2',
    element: <TenantBookingPageV2 />,
  },
  {
    path: '/driver-sign/:token',
    element: <DriverSignPage />,
  },
  {
    path: '/',
    element: <Layout />,
    loader: checkAuth,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'orders',
        element: <OrdersPage />,
      },
      {
        path: 'orders/:orderId',
        element: <OrderDetailPage />,
      },
      {
        path: 'dispatch-board',
        element: <DispatchBoardPage />,
      },
      {
        path: 'drivers',
        element: <DriversPage />,
      },
      {
        path: 'drivers/:driverId',
        element: <DriverDetailPage />,
      },
      {
        path: 'customers',
        element: <CustomersPage />,
      },
      {
        path: 'customers/:customerId',
        element: <CustomerDetailPage />,
      },
      {
        path: 'users',
        element: <UsersPage />,
      },
      {
        path: 'tenants',
        element: <TenantsPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'reports/drivers',
        element: <DriverReportPage />,
      },
      {
        path: 'reports/customers',
        element: <CustomerReportPage />,
      },
      {
        path: 'reports/vendors',
        element: <VendorRebateReportPage />,
      },
      {
        path: 'reports/xunan-sign',
        element: <XunanSignReportPage />,
      },
      {
        path: 'reports/documents',
        element: <DocumentTestPage />,
        loader: checkSuperAdmin,
      },
      {
        path: 'expenses',
        element: <ExpensesPage />,
        loader: checkSuperAdmin,
      },
      {
        path: 'my-expenses',
        element: <DriverMyExpensesPage />,
        loader: checkAuth,
      },
      {
        path: 'my-report',
        element: <DriverMyReportPage />,
        loader: checkAuth,
      },
      {
        path: 'batch-orders',
        element: <BatchOrdersPage />,
        loader: checkBatchOrdersAccess,
      },
    ],
  },
])
